export default __webpack_public_path__ + "static/media/route.51a59b82.svg";